import { createSelector } from 'reselect'

export const getDocuments = (state) => state.mars.documents

export const getDocumentsList = createSelector([getDocuments], (documents) => documents.docs)
